import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CustomCookieService } from '../../../../shared/services/custom-cookie.service';

import { FormControl, Validators } from '@angular/forms';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { PlansManagementService } from '../../../../shared/services/plans-management.service';
import { get } from 'lodash';

@Component({
  selector: 'app-mdn',
  templateUrl: './mdn.component.html',
  styleUrls: ['./mdn.component.scss'],
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation()
  ]
})
export class MdnComponent implements OnInit {
  public mdnList: string[];
  public mdnControl: FormControl = new FormControl('', Validators.required)

  constructor(
    private router: Router,
    private customCookieService: CustomCookieService,
    private plansManagementService: PlansManagementService
  ) { }

  ngOnInit(): void {
    this.fetchMdnList();
  }

  onConfirm() {
    this.customCookieService.saveData('ui-selectedMdn', this.mdnControl.value, '/', true);
    this.router.navigate(['account/select-plan'], {
      queryParams: {mdn: this.mdnControl.value}
    });
  }

  public fetchMdnList() {
    this.plansManagementService.getMDNList().subscribe({
      next: (item: any) => {
        const mdnList = get(item,'[0].mtnList');
        if (!mdnList || !mdnList.length) {
          this.router.navigate(['main/eligibility-error']);
          return;
        }
        this.customCookieService.saveData('mtnList', mdnList)
        this.customCookieService.saveData('billAccountNumber', get(item,'[0].billAccountNumber'))
        this.checkMdnList()
      },
      error: (error: Error) => {
        this.router.navigate(['main/eligibility-error']);
      }
    })
  }

  private checkMdnList() {
    this.mdnList = this.customCookieService.getData('mtnList');
    if ((this.mdnList || []).length === 1) {
      this.router.navigate(['/select-plan'])
    }
  }

}
